//PrintButtonControlView

import eventBus         from 'EventBus';
import BaseControlView from 'BaseControlView';
import template from 'advanced-visuals/control_print_button.ejs';
import constants        from "Constants";
//=====================================================================
//
// An instance of this view represents a print button control
//
// Maty Rocha, February 23, 2016
//
//=====================================================================
class PrintButtonControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;

        this.tagName = 'div';

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, 'ButtonThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'PrintButtonControlView';
    }


}

export default PrintButtonControlView;
